// src/components/customers/tabs/tabs-Affiliate.jsx
import React from "react";
export default function AffiliateTab() {
  return <div className="oc-empty">No affiliate data</div>;
}

